/* ============================================================================
   SALTELE — titlu dinamic la schimbarea variantei (epic lp-3fo, T4)
   ----------------------------------------------------------------------------
   Actualizează H1 + document.title când clientul trece de pe o saltea pe alta
   (ex. 160x200 → 180x200), FĂRĂ reload și FĂRĂ nicio modificare în theme.js.

   CE VEDE GOOGLE: nimic din ce face fișierul ăsta. Titlul e compus SERVER-SIDE
   (Liquid) și livrat în HTML; JS-ul se declanșează doar la interacțiune umană
   (change/click/popstate), pe care crawler-ul nu o produce. Canonical-ul temei
   e URL-ul fără ?variant=, deci se indexează un singur titlu per produs — cel
   randat de Liquid. Fișierul e strict aditiv: șters, pagina rămâne corectă.

   PRINCIPIU: ZERO logică de compunere aici. Titlurile sunt pre-compuse SERVER-SIDE
   de `snippets/dc_saltea-title.liquid` pentru fiecare variantă și livrate ca JSON
   island (`#dc-saltea-titles`). JS-ul doar mapează variant_id → titlu. Așa rețeta
   trăiește într-un SINGUR loc; dacă se schimbă, nu există a doua copie rămasă în urmă.

   TREI CĂI de detecție a schimbării, fiindcă theme.js poate lipsi (temă parțial
   încărcată, alt template) și `history.replaceState` NU emite evenimente:
     1. evenimentul `variantChange` emis de theme.js (jQuery)
     2. `popstate`
     3. plasă de siguranță: change/click în pagina de produs, apoi recitim ?variant=

   FAIL-SOFT peste tot: fără island, fără H1 sau fără varianta în hartă → nu facem nimic.
============================================================================ */
(function () {
  'use strict';

  var island = document.getElementById('dc-saltea-titles');
  if (!island) return;                       // pagina nu e saltea → ieșim tăcut

  var TITLURI = null;
  try { TITLURI = JSON.parse(island.textContent || '{}'); } catch (e) { return; }
  var CHEI = TITLURI ? Object.keys(TITLURI) : [];
  if (!CHEI.length) return;

  // lp-3fo.8: pot fi MAI MULTE ținte în pagină (H1 + ultimul element din breadcrumb),
  // toate marcate cu data-dc-saltea-title — se actualizează toate deodată.
  var tinte = document.querySelectorAll('[data-dc-saltea-title]');

  // Titlul paginii NU are sufix de magazin: tema randează `<title>{{ page_title }}</title>`
  // gol-goluț, iar Shopify nu adaugă automat numele magazinului (verificat live) — deci
  // înlocuim titlul întreg, fără logică de „păstrează sufixul".
  //
  // ⚠️ DAR: 11 din 49 de saltele au titlu SEO scris MANUAL în Admin, iar SEOManager îl
  // păstrează intenționat (deciziile umane supraviețuiesc). Ca să nu-l stricăm din JS,
  // atingem `document.title` DOAR dacă cel curent e chiar unul dintre titlurile compuse
  // de noi. Dacă e altceva (titlu manual), îl lăsăm în pace — actualizăm doar H1.
  var titluCurent = (document.title || '').trim();
  var titluEsteAlNostru = false;
  for (var i = 0; i < CHEI.length; i++) {
    if (String(TITLURI[CHEI[i]]).trim() === titluCurent) { titluEsteAlNostru = true; break; }
  }

  var ultimul = null;

  function aplica(variantId) {
    if (!variantId) return;
    var t = TITLURI[String(variantId)];
    if (!t || t === ultimul) return;
    ultimul = t;
    for (var k = 0; k < tinte.length; k++) tinte[k].textContent = t;
    if (titluEsteAlNostru) document.title = t;
    // microdata: ținem datele structurate sincronizate cu ce vede clientul
    var meta = document.querySelector('meta[itemprop="name"]');
    if (meta) meta.setAttribute('content', t);
  }

  function dinUrl() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  // ── 1. evenimentul temei (calea principală) ────────────────────────────────
  if (window.jQuery) {
    window.jQuery(document).on('variantChange', function (evt) {
      if (evt && evt.variant && evt.variant.id) aplica(evt.variant.id);
    });
  }

  // ── 2. navigare în istoric ─────────────────────────────────────────────────
  window.addEventListener('popstate', function () { aplica(dinUrl()); });

  // ── 3. plasă de siguranță: theme.js scrie ?variant= prin history.replaceState,
  //    care nu emite niciun eveniment — deci recitim URL-ul la scurt timp după
  //    orice interacțiune din pagina de produs.
  function verificaCurand() { setTimeout(function () { aplica(dinUrl()); }, 60); }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form, .product-form, .single-product-page')) verificaCurand();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.single-product-page')) verificaCurand();
  }, true);

  // stare inițială (deep-link ?variant= — server-side e deja corect, ne aliniem harta)
  aplica(dinUrl());
})();
